import { render } from "./feedbackList.vue?vue&type=template&id=0d2dde61"
import script from "./feedbackList.vue?vue&type=script&lang=js"
export * from "./feedbackList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/sale/feedbackList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d2dde61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d2dde61', __exports__)) {
    api.reload('0d2dde61', __exports__)
  }
  
  module.hot.accept("./feedbackList.vue?vue&type=template&id=0d2dde61", () => {
    api.rerender('0d2dde61', render)
  })

}


export default __exports__